import autosize from "autosize";

$(function () {
    //Do yo JAHVAHSCRIPT here.


    //run this if there's a section with tetroids.
    if ($('.narrow-width-tetroids').length > 0 ) {

        // SHAPES ANIMATION -- START
        // This displays falling blocks using the ::after pseudo element.
        // It does require a <section> ABOVE/BELOW to hide behind.
        // Warning! This is fragile, as moving the element will require modifying this.

        // Detect when in viewpoint: https://usefulangle.com/post/113/javascript-detecting-element-visible-during-scroll
        // Debouncing: https://gomakethings.com/debouncing-events-with-requestanimationframe-for-better-performance/
        // Scroll direction: https://stackoverflow.com/questions/31223341/detecting-scroll-direction

        // declare variables globally
        let timeout;
        let tetroids = document.querySelector(".narrow-width-tetroids").style;
        let tetroidsTransform = `translate(0px, -250px)`;  //hacking the ::after
        tetroids.setProperty("--translate", tetroidsTransform);

        let tetroidsX = 0;
        let lastScrollTop = 0;
        let scrollingStarts = 4000;
        let scrollingEnds = document.body.offsetHeight - 1200;

        // Get the width of viewport to check if it's not desktop
        const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        // If tetroids on-screen, have them scroll faster than the text.
        let observer = new IntersectionObserver(function (entries) {
            if (vw > 1199) {
                //when element and viewport are overlapping, make it visible.
                if (entries[0].isIntersecting === true) {
                    moveTheTetroids();
                }
            }
        }, {threshold: [0]});

        observer.observe(document.querySelector("#shapeBlocksBackground"));

        function onScroll(currentScrollX) {
            // It first tracks to see if the div is on-screen. Debounced for optimization.
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }

            timeout = window.requestAnimationFrame(function () {
                // Run our scroll function - 6000 was after a lot of testing
                tetroidsX = (currentScrollX - 6000) / 1.5;

                tetroidsTransform = `translate(0px, ${tetroidsX}px)`;
                tetroids.setProperty("--translate", tetroidsTransform);

                // lock at value, unless scrolling between Starts and Ends value.
                if (currentScrollX < scrollingStarts || currentScrollX > scrollingEnds) {
                    tetroids.setProperty("--translate", "translate(0px, -950px)");
                }
            });
        }

        const moveTheTetroids = () => {
            window.addEventListener('scroll', function (event) {
                let st = window.pageYOffset || document.documentElement.scrollTop;

                onScroll(lastScrollTop);
                // For Mobile or negative scrolling
                lastScrollTop = st <= 0 ? 0 : st;

            }, false);
        }
        // END ANIMATION

        //mobile nav controller
        $('.mobile-nav-trigger').on('click', function () {
            $(this).toggleClass('active');
            $('nav.nav').toggleClass('mobile-menu-open');
        });

        autosize($('textarea'));

    }
});
